'use client';

import React from 'react';
import { CalendarDays } from 'lucide-react';
import { DatePickerInput } from '@mantine/dates';

interface DateSelectorProps {
  startDate: Date | null;
  endDate: Date | null;
  handleDateChange: (field: 'startDate' | 'endDate', date: Date | null) => void;
}

const DateSelector: React.FC<DateSelectorProps> = ({
  startDate,
  endDate,
  handleDateChange
}) => {
  return (
    <div className="space-y-4 sm:space-y-0 grid grid-cols-2 gap-3">
      <div className="space-y-1">
        <label className="block text-sm font-medium text-gray-700 sm:hidden">Start Date</label>
        <DatePickerInput
          value={startDate}
          onChange={(date) => handleDateChange('startDate', date)}
          placeholder="Start Date"
          minDate={new Date()}
          leftSection={<CalendarDays className="w-5 h-5 text-gray-400" />}
          classNames={{
            input: "pl-12 pr-4 py-4 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-green-500/20 focus:border-green-500 text-gray-900 text-base font-medium transition-all duration-300 bg-white h-auto",
            wrapper: "w-full"
          }}
          required
        />
      </div>
      
      <div className="space-y-1">
        <label className="block text-sm font-medium text-gray-700 sm:hidden">End Date</label>
        <DatePickerInput
          value={endDate}
          onChange={(date) => handleDateChange('endDate', date)}
          placeholder="End Date"
          minDate={startDate || new Date()}
          leftSection={<CalendarDays className="w-5 h-5 text-gray-400" />}
          classNames={{
            input: "pl-12 pr-4 py-4 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-green-500/20 focus:border-green-500 text-gray-900 text-base font-medium transition-all duration-300 bg-white h-auto",
            wrapper: "w-full"
          }}
          disabled={!startDate}
          required
        />
      </div>
    </div>
  );
};

export default DateSelector;